import AppsList from "components/AppsList"
import useT from "utils/useT"
import useFetchApps from "utils/useFetchApps"
import { fetchApps } from "queries"
import usePullToRefresh from "utils/usePullToRefresh"
import useIntersectionObserver from "utils/useIntersectionObserver"
import { useRef } from "react"
import useFiltersStore from "stores/filters"

const Apps = () => {
  const t = useT()
  const price = useFiltersStore((state) => state.price)

  const {
    data: apps,
    isFetchingNextPage,
    refetch,
    fetchNextPage,
  } = useFetchApps({
    queryFn: ({ pageParam }) => fetchApps({ price, pageParam }),
    queryKey: price ? ["getApps", price] : ["getApps"],
  })

  usePullToRefresh({ refetch, element: "#apps-card", page: "apps" })
  const ref = useRef<HTMLDivElement | null>(null)
  useIntersectionObserver(ref, fetchNextPage, isFetchingNextPage, {}, "apps")

  return (
    <div id="apps-card">
      <AppsList
        title={t.apps.latestApps}
        apps={apps}
        isPending={isFetchingNextPage}
      />
      <div ref={ref}></div>
    </div>
  )
}
export default Apps
